import { callGTMEvent } from "./datalayer";

$(document).ready(function() {
    $('.list-box-links--extra .box--square-link--more').on('click', function() {
        $(this).closest('.list-box-links--extra').addClass('active');
    });
});

$(window).on('load', function() {
    var handled = {};
    $('.box--square-link:not(button), .slider-deals--item, #product-picks a, #learning-centre-articles a, .btn-show-more').click(function(e) {
        var link = $(this)[0];
        var linkId = link['dataset']['region'] + link['dataset']['description'] + link['dataset']['value'];
        if (!handled[linkId]) {
            handled[linkId] = true;
            e.preventDefault();
            e.stopPropagation();
            prepGTMEvent('click', this).then(() => setTimeout(() => link.click()));
        } else {
            //reset
            handled[linkId] = false;
        }
    });
})

// Added for datalayer for Moengage
const getDeviceType = () => {
    const ua = navigator.userAgent;
    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
        return "Tablet";
    }
    if (
        /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
            ua
        )
    ) {
        return "Mobile";
    }
    return "Desktop";
};

async function prepGTMEvent(eventname, clickObj) {
    var dataLayerTemp = {
        event: eventname,
        data_action: $(clickObj).attr('data-action'),
        data_region: $(clickObj).attr('data-region'),
        data_value: $(clickObj).attr('data-value'),
        data_subject: $(clickObj).attr('data-subject'),
        data_vertical: $(clickObj).attr('data-vertical'),
        data_description: $(clickObj).attr('data-description')
    };
    
    return callGTMEvent(eventname, dataLayerTemp);
}